import { Modal, Spin, Button } from "antd";
import React, { useEffect, useState } from "react";
import { InformationCircleIcon } from "@heroicons/react/16/solid";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

interface PDFPreviewProps {
  pdfURL: string | null;
  opened: boolean;
  handleOpen: (opened: boolean) => void;
  loading: boolean;
  fileError: string;
  onOpenInNewTab?: (url: string) => void;
}

export const PDFPreview: React.FC<PDFPreviewProps> = ({
  pdfURL,
  opened,
  handleOpen,
  loading,
  fileError,
  onOpenInNewTab,
}) => {
  const [pdfUrl, setPdfUrl] = useState<string>("");

  useEffect(() => {
    if (opened && pdfURL) {
      setPdfUrl(pdfURL);
    }
  }, [opened, pdfURL]);

  const onModalClose = () => {
    handleOpen(false);
  };

  return (
    <Modal
      title={
        <div className="flex justify-between items-center mr-10">
          <span>Vista previa del Multireporte de Inquilino</span>
          {onOpenInNewTab && pdfURL && !loading && !fileError && (
            <Button
              type="primary"
              icon={<ArrowTopRightOnSquareIcon className="h-4 w-4" />}
              onClick={() => onOpenInNewTab?.(pdfUrl)}
              size="small"
            >
              Abrir en nueva pestaña
            </Button>
          )}
        </div>
      }
      open={opened}
      onCancel={onModalClose}
      width="90%"
      centered
      footer={null}
    >
      <div className="p-0 h-screen max-h-[90vh] overflow-hidden">
        {loading ? (
          <div className="flex flex-col justify-center items-center h-full gap-4">
            <Spin size="large" />
            <span>Cargando Archivo...</span>
          </div>
        ) : fileError ? (
          <div className="flex flex-col justify-center items-center h-full gap-4 text-center">
            <InformationCircleIcon className="w-10 h-10 text-blue-500" />
            <span className="text-xl text-red-400">{fileError}</span>
          </div>
        ) : (
          <div className="w-full h-full overflow-hidden">
            <iframe
              id="preview-pdf"
              title={undefined}
              className="w-full h-full mt-6"
              src={pdfUrl}
              onError={() => console.error("Failed to load PDF document.")}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};
